import * as React from 'react'
import { getCountryData, getCountryNameByCode, getCountryCodeByName } from 'utils/getCountryList'
import { useActions, useAppSelector } from 'hooks'
import { comparingCountries, countryType, tool } from 'store/AIMetricOT/reducerSlice'
import SearchDropdown from 'components/common/SearchDropdown/SearchDropdown'
import useDebouncedDispatch from 'hooks/useDebouncedDispatch'

const CountrySearchDropdown: React.FC<{
  defaultCountry?: string
  width?: number
  height?: number
  index?: number
  isTableView?: boolean
}> = ({ defaultCountry = 'USA', width = 220, height = 40, index = 0, isTableView = false }) => {
  const selectedCountriesForComparison = useAppSelector(comparingCountries)
  const { setCountry, setCountryType } = useActions()
  const currentTool = useAppSelector(tool)
  const currentCountryType = useAppSelector(countryType)
  const isGlobal = currentCountryType === 'global'
  const isAIMOT = currentTool === 'AIMOT'
  const countryData = useAppSelector(({ vibrancy }) => vibrancy.countryData)
  const countryDataList = getCountryData(countryData)
  const getDebouncedDispatcher = useDebouncedDispatch(500)

  const dataList = countryDataList.map((el) => {
    const countryCode = getCountryCodeByName(el.countryName, countryDataList)
    const isDisabled = countryCode ? selectedCountriesForComparison!.includes(countryCode) : false

    return {
      value: el.countryName,
      isDisabled: isTableView && isDisabled,
    }
  })
  const dataAIMOTList = [
    // {
    //   value: 'Global',
    //   isDisabled: false,
    // },
    ...dataList,
  ]

  // const currentCountryName = isAIMOT && isGlobal ? 'Global' : getCountryNameByCode(defaultCountry, countryDataList)
  const currentCountryName =
    isAIMOT && isGlobal
      ? getCountryNameByCode(defaultCountry, countryDataList)
      : getCountryNameByCode(defaultCountry, countryDataList)

  const handleChangeCountry = (event: React.SyntheticEvent, value: any) => {
    const currentCountryCode = getCountryCodeByName(value, countryDataList)
    if (currentCountryCode) {
      const debouncedCountryUpdate = getDebouncedDispatcher(setCountry)
      debouncedCountryUpdate({ country: currentCountryCode })

      const debouncedCountryTypeUpdate = getDebouncedDispatcher(setCountryType)
      debouncedCountryTypeUpdate({ countryType: 'national' })
    } else if (value === 'Global') {
      const debouncedCountryTypeUpdate = getDebouncedDispatcher(setCountryType)
      debouncedCountryTypeUpdate({ countryType: 'global' })
    }
  }

  return (
    <SearchDropdown
      id='country-dropdown'
      size='small'
      value={currentCountryName}
      handleStateUpdate={handleChangeCountry}
      data={!isAIMOT ? dataList : dataAIMOTList}
      width={width}
      height={height}
      fontSize={15}
    />
  )
}
export default CountrySearchDropdown
